import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import type { ColumnsType } from 'antd/es/table';
import { getRefferersPaymentList } from '../../actions/refer';
import { Table } from 'antd';
import PaymentModal from './PaymentModal';
import moment from 'moment';


interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}


export const Referrerpayment = () => {
    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state: any) => state?.General);
    
    useEffect(() => {
        const payload = { limit: pageSize, page };
        dispatch(
            getRefferersPaymentList(payload, (resp: any) => {
                if (resp?.status === 200) {
                    setData(resp?.data);
                    setPagination(resp?.pagination);
                }
            })
        );
    }, [page, pageSize, dispatch]);
    
    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };



    const columns: ColumnsType<DataType> = [
        {
            title: 'Payment date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: (a: any, b: any) => a?.createdAt?.localeCompare(b?.createdAt),
            render: (text) => {
                return <>{text ? moment(text).format('DD/MM/YYYY') : ""}</>
            }
        },
        {
            title: 'Name',
            dataIndex: 'referredTo',
            key: 'referredTo',
            sorter: (a: any, b: any) => a?.referredTo?.invite?.firstName?.localeCompare(b?.referredTo?.invite?.firstName),
            render: (text) => {
                return <>{`${text?.invite?.firstName ?? text?.invite?.firstName} ${text?.invite?.lastName ?? text?.invite?.lastName}`}</>
            }
        },
        {
            title: 'Email',
            dataIndex: 'referredTo',
            key: 'referredTo',
            sorter: (a: any, b: any) => a?.referredTo?.invite?.email?.localeCompare(b?.referredTo?.invite?.email),
            render: (text) => {
                return <>{text?.invite?.email}</>
            },
        },
        {
            title: 'Total Referral',
            dataIndex: 'referralsCount',
            key: 'referralsCount',
            // sorter: (a: any, b: any) => a?.senderCode?.localeCompare(b?.senderCode),
            render: (text) => <>{text ?? text}</>,
        },
        {
            title: 'Total Paid',
            dataIndex: 'amount',
            key: 'amount',
            // sorter: (a: any, b: any) => Number(a?.invite?.isRegistered) - Number(b?.invite?.isRegistered),
            render: (record: any) => (
                <>{record ? `$${record}` : ""}</>
            ),
        }
    ];
    
    return <div>
        <div className="cardContentbody">
            <div className="responsivetable">
                <Table
                    size='small'
                    columns={columns}
                    dataSource={data}
                    loading={isLoading}
                    pagination={{
                        total: pagination?.totalItems,
                        pageSize,
                        current: page,
                        showSizeChanger: true,
                        pageSizeOptions: ['20', '50'],
                    }}
                    scroll={{ y: 264, x: 800 }}
                    onChange={handleTableChange}
                    rowKey='email'
                />
            </div>
            <PaymentModal visible={showPaymentModal} setVisible={setShowPaymentModal} />
        </div>
    </div>;
};
